// extracted by mini-css-extract-plugin
export var container = "_pe-0";
export var dotAnimation = "_pe-2";
export var dotsLoading = "_pe-1";